import React from 'react';

import { Container } from './styles';

export default function Loading() {
  return (
    <Container>
      <span></span>
      <span></span>
      <span></span>
    </Container>
  );
}
